<template>
  <div>
    <h1>艾奇科技有限公司</h1>
    <div class="app-background"></div>
    <div id="nav" :class="{'fixed':isFixed, 'float':!isFixed}">
      <div class="main" :class="{'box-fixed':isFixed, 'box-top':!isFixed,'fixed':isFixed, 'float':!isFixed}" @mouseover="mouseoverLogo" @mouseleave="mouseleaveLogo">
        <div class="logo">
          <img :src="imgSrc"  class="logo-img"  alt="艾奇"/>
        </div>
        <div class="items">
          <ul>
            <li><a href="/home"><div class="title" :class="{'now-router-checked':nowRouterIndex==1}">首页</div></a></li>
            <li class="active-list"><a href="/solution"><div class="title" :class="{'now-router-checked':nowRouterIndex==2}">解决方案</div></a>
              <div class="active-options">
                <p @click="$router.push('/solution?model=bluetooth')">蓝牙智能</p>
                <p @click="$router.push('/solution?model=video')">无线视频</p>
                <p @click="$router.push('/solution?model=ultrasound')">超声波</p>
                <p @click="$router.push('/solution?model=voice')">语音控制</p>
              </div>
            </li>
            <li class="active-list"><a href="/wpt"><div class="title" :class="{'now-router-checked':nowRouterIndex==6}">万品通服务</div></a>
            </li>
            <li class="active-list"><a href="/design"><div class="title" :class="{'now-router-checked':nowRouterIndex==3}">工业设计</div></a>
              <div class="active-options">
                <p @click="$router.push('/design?arch=a1&time='+Date.now())">以色简介</p>
                <p @click="$router.push('/design?arch=a2&time='+Date.now())">案例展示</p>
                <p @click="$router.push('/design?arch=a3&time='+Date.now())">以色官网</p>
              </div>
            </li>
            <li ><a href="/service"><div class="title" :class="{'now-router-checked':nowRouterIndex==4}">ODS服务</div></a></li>
            <li class="active-list"><a href="/about"><div class="title" :class="{'now-router-checked':nowRouterIndex==5}">关于艾奇</div></a>
              <div class="active-options">
                <p @click="$router.push('/about?arch=a1&time='+Date.now())">公司简介</p>
                <p @click="$router.push('/about?arch=a2&time='+Date.now())">使命愿景</p>
                <p @click="$router.push('/about?arch=a7&time='+Date.now())">企业方法论</p>
                <p @click="$router.push('/about?arch=a5&time='+Date.now())">企业价值观</p>
                <p @click="$router.push('/about?arch=a4&time='+Date.now())">艾奇团队</p>
                <p @click="$router.push('/about?arch=a3&time='+Date.now())">专利资质</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
<!--      移动端适配-->
      <div class="main-mobile">
        <div class="logo">
          <img src="https://website.obs.icheer.cn/icheer-web/images1/nav/logo-black-2026.png" alt="艾奇"/>
        </div>
        <div class="items">
          <div class="area">
            <div class="panel" >
              <span class="nav-button"></span>
            </div>
          </div>
        </div>
        <div class="active-list">
          <li>
            <span>
              <p @click="$router.push('/home')">首页</p>
            </span>
          </li>
          <li>
            <span>
              <p @click="$router.push('/solution')">解决方案</p>
              <svg></svg>
            </span>
            <ul>
              <li>
                <a href="/solution?model=bluetooth">蓝牙智能<i></i></a>
              </li>
              <li>
                <a href="/solution?model=video">无线视频<i></i></a>
              </li>
              <li>
                <a href="/solution?model=ultrasound">超声波<i></i></a>
              </li>
              <li>
                <a href="/solution?model=voice">语音控制<i></i></a>
              </li>
            </ul>
          </li>
          <li>
            <span>
              <p @click="$router.push('/design')">工业设计</p>
              <svg></svg>
            </span>
            <ul>
              <li>
                <a href="/design?arch=a1">以色简介<i></i></a>
              </li>
              <li >
                <a href="/design?arch=a2">案例展示<i></i></a>
              </li>
              <li>
                <a href="/design?arch=a3">以色官网<i></i></a>
              </li>
            </ul>
          </li>
          <li>
            <span>
              <p @click="$router.push('/wpt')">万品通服务</p>
            </span>
          </li>
          <li>
            <span>
              <p @click="$router.push('/service')">ODS服务</p>
            </span>
          </li>
          <li >
            <span>
              <p @click="$router.push('/about')">关于艾奇</p>
              <svg></svg>
            </span>
            <ul>
              <li>
                <a href="/about?arch=a1">公司简介<i></i></a>
              </li>
              <li>
                <a href="/about?arch=a2">使命愿景<i></i></a>
              </li>
              <li>
                <a href="/about?arch=a5">企业价值观<i></i></a>
              </li>
              <li>
                <a href="/about?arch=a4">艾奇团队<i></i></a>
              </li>
              <li>
                <a href="/about?arch=a3">专利资质<i></i></a>
              </li>
            </ul>
          </li>
        </div>
      </div>
    </div>
    <div class="navBox">
      <el-popover placement="left" :width="140" trigger="hover" :hide-after="0" >
        <div class="qrcode-part">
          <div style="padding-bottom:6px;">在线提问</div>
          <img src="https://website.obs.icheer.cn/icheer-web/images1/nav/service-qrcode.png" style="width:120px">
        </div>
        <template #reference>
          <img style="width: 22px;height: 22px;padding: 10px 2px;cursor: pointer;" src="https://website.obs.icheer.cn/icheer-web/images1/nav/service.png" alt="">
        </template>
      </el-popover>
      <div class="line"></div>
      <el-popover placement="left" :width="140" trigger="hover" :hide-after="0">
        <div class="phone-text">
          <span>电话咨询</span><span>13559623102</span>
        </div>
        <template #reference>
          <img style="width: 22px;height: 22px;padding: 10px 2px;cursor: pointer;" src="https://website.obs.icheer.cn/icheer-web/images1/nav/phone.png" alt="13559623102">
        </template>
      </el-popover>
      <div class="to-top" @click="toTop">
        <img src="https://website.obs.icheer.cn/icheer-web/images/arrow.png" style="width: 26px;height: 26px;cursor: pointer;" alt="">
      </div>
    </div>
    <router-view/>
    <Footer/>
  </div>
</template>
<script>
import Footer from '@/components/footer.vue'
import $ from '../public/static/jquery.min'

export default {
  components: { Footer },
  data () {
    return {
      imgSrc: 'https://website.obs.icheer.cn/icheer-web/images/logo/logo-w-2026.png',
      isFixed: false,
      nowRouterIndex: 1
    }
  },
  methods: {
    toTop: () => {
      window.scrollTo(0, 0)
    },
    handleScroll () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 400) {
        // console.log('scroll fixed')
        this.imgSrc = 'https://website.obs.icheer.cn/icheer-web/images/logo/logo-black-2026-en.png'
        this.isFixed = true
      } else {
        this.imgSrc = 'https://website.obs.icheer.cn/icheer-web/images/logo/logo-w-2026.png'
        this.isFixed = false
      }
    },
    mouseoverLogo () {
      this.imgSrc = 'https://website.obs.icheer.cn/icheer-web/images/logo/logo-black-2026-en.png'
    },
    mouseleaveLogo () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 400) {
        this.imgSrc = 'https://website.obs.icheer.cn/icheer-web/images/logo/logo-black-2026-en.png'
      } else {
        this.imgSrc = 'https://website.obs.icheer.cn/icheer-web/images/logo/logo-w-2026.png'
      }
    },
    toNav () {
      this.isOpen = !this.isOpen
    }
  },
  watch: {
    $route (to, from) {
      console.log('1当前页面路由：' + to.path)
      switch (to.path) {
        case '/solution':
          this.nowRouterIndex = 2
          break
        case '/design':
          this.nowRouterIndex = 3
          break
        case '/service':
          this.nowRouterIndex = 4
          break
        case '/about':
          this.nowRouterIndex = 5
          break
        default:
          this.nowRouterIndex = 1
      }
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll, true)
    $('.area').click(function () {
      $(this).find('.panel').toggleClass('active')
      $('.active-list').toggleClass('active')
    })
    $('.active-list li').on('click', function () {
      if (!$(this).hasClass('active')) {
        $('li').each(function () {
          if ($(this).hasClass('active')) {
            $(this).removeClass('active')
          }
        })
      }
      if ($(this).find('svg').length > 0) {
        $(this).toggleClass('active')
      }
    })
  },
  unmounted () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>
<style>
@import "/fonts/HarmonyOS_Sans/HarmonyOS_Sans_SC_Regular.css";
@import "/fonts/HarmonyOS_Sans/HarmonyOS_Sans_SC_Medium.css";

body {
  color: black;
  font-family: HarmonyOS_Sans_SC_Regular;
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
}
h1{
  display: none;
}

#app,body,html,li,ul {
  list-style: none;
  margin: 0;
  padding: 0;
  scrollbar-width: none;
}

h3,h4{
  font-family: HarmonyOS_Sans_SC_Medium;
}

#app {
  background: url(https://website.obs.icheer.cn/icheer-web/images1/app/background.jpg) no-repeat fixed;
  background-size: 100% 100%
}

.app-background{
  background: url('https://website.obs.icheer.cn/icheer-web/images/dw.jpg?x-image-process=image/resize,w_1920,limit_0') no-repeat fixed;
  background-size:100% 100%;
  opacity: 0.5;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: -1;
}

#nav {
  width: 100%;
  height: 71.76px;
  position: absolute;
  top: 0;
  z-index: 99999
}

#nav .main {
  width: 100%;
  height: 71.76px;
  display: flex;
  flex-direction: row
}

#nav .main .logo {
  width: 35%;
  height: auto;
  padding-top: 5px;
  padding-left: 100.05px;
  border: 0vw solid #e5e5e5;
}
#nav .main .logo>img{
  width: 50%;
  max-width: 220px;
  object-fit: contain;
  border: 0vw solid #e5e5e5;
}
#nav .main .items{
  width: 65%;
  height: auto;
  padding-top: 20.7px;
  display: flex;
  justify-content: flex-end
}

#nav .main .items>ul>li,
#nav .main .items>ul {
  width: auto;
  height: 100%;
  display: inline-block
}

#nav .main .items>ul>li {
  margin: auto 70.38px auto auto
}

#nav .main .items>ul>li>a {
  display: inline-block;
  text-decoration: none
}

#nav .main .items>ul>li>a .title{
  font-size: 16.146px;
  line-height: 30.36px;
  padding-top: 2.76px;
  color: #fff
}

#nav.fixed .main .items>ul>li>a .title {
  color: #000
}

#nav .main .items>ul>li:hover>a .title{
  border-bottom: 3.45px solid #0151da
}

#nav .main .active-list{
  position: relative;
  width: auto;
  height: auto
}

#nav .main .active-options {
  font-size: 13.8px;
  width: 138px;
  color: #fff;
  display: block;
  visibility: hidden;
  background-color: rgba(88,88,88,.8);
  overflow: hidden;
  cursor: pointer;
  position: absolute;
  text-align: center;
  left: -38.64px;
  top: 51.06px
}

#nav .main .active-list:hover .active-options,
#nav .main .active-options:hover {
  visibility: visible
}

#nav .main .active-options p {
  margin: 0;
  padding: 13px 0
}

#nav .main .active-options p:hover {
  font-weight: 800;
  background-color: #0151da
}

#nav .main.float:hover {
  background-color: #fff
}

#nav .main.float:hover .title {
  color: #000
}

#nav .main.fixed {
  position: fixed;
  top: 0;
  box-shadow: 2px 2px 5px 2px #eeeded;
  background-color: #fff
}

#nav .main.fixed .title{
  color: #000
}

#nav .main-mobile{
  width: 100%;
  height: 100%;
  display: none;
  flex-direction: row;
}

#nav .main-mobile .logo {
  width: 80%;
  height: 100%;
  padding-left: 10px;
  display: flex;
  align-items: center
}

#nav .main-mobile .logo img{
  max-height: 35px;
  object-fit: contain
}

#nav .main-mobile .items{
  width: 20%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center
}

#nav .main-mobile .items .area {
  float: right;
  cursor: pointer;
  width: 5vw;
  height: 100%;
  position: relative;
  margin-right: 1vw
}

#nav .main-mobile .area .panel {
  width: 5vw;
  height: 100%;
  display: block
}

#nav .main-mobile .area .panel .nav-button{
  width: 2.8vw;
  height: 2px;
  position: absolute;
  top: 20px;
  right: 1vw;
  display: inline-block;
  transition: all .3s ease-out 0s;
  background: #000;
  z-index: 99999
}

#nav .main-mobile .area .panel .nav-button:after,
#nav .main-mobile .area .panel .nav-button:before {
  position: absolute;
  right: 0;
  display: inline-block;
  width: 2.8vw;
  height: 2px;
  content: "";
  transition: all .3s ease-out 0s;
  background: #000;
  border-radius: 4px
}

#nav .main-mobile .area .panel .nav-button:before {
  top: 6px
}

#nav .main-mobile .area .panel .nav-button:after {
  top: -6px
}

#nav .main-mobile .area .panel.active .nav-button {
  background: transparent
}

#nav .main-mobile .area .panel.active .nav-button:before {
  transform: rotate(-45deg);
  top: 0
}

#nav .main-mobile .area .panel.active .nav-button:after {
  transform: rotate(45deg);
  top: 0
}

#nav .main-mobile .active-list {
  width: 100%;
  height: 400px;
  background-color: #fff;
  position: absolute;
  top: 39.5px;
  display: none;
  box-shadow: 0.5px 0.5px 1px 0.5px #cecbcb
}

#nav .main-mobile .active-list.active{
  display: block
}

#nav .main-mobile .active-list>li{
  float: left;
  width: 100%;
  height: auto;
  min-height: 40px;
  position: relative;
  display: block;
  border-bottom: 1px dashed #ccc
}

#nav .main-mobile .active-list>li span {
  float: left;
  width: 100%;
  height: 100%;
  cursor: pointer
}

#nav .main-mobile .active-list>li span>p {
  float: left;
  width: 100%;
  height: 28px;
  color: #000;
  font-size: 14px;
  white-space: nowrap;
  position: relative;
  letter-spacing: 1px;
  margin: 0;
  padding: 13px 0 0 2vw
}

#nav .main-mobile .active-list>li.active span>p {
  color: #c30d23
}

#nav .main-mobile .active-list>li span>svg {
  display: block;
  width: 40px;
  height: 40px;
  position: absolute;
  right: 0;
  top: 0;
  background: url(https://website.obs.icheer.cn/icheer-web/images1/nav/arrow-right.png) no-repeat 50%;
  background-size: auto 14px;
  transition: all 0.3s ease-out 0s
}

#nav .main-mobile .active-list>li.active span>svg {
  transform: rotate(90deg)
}

#nav .main-mobile .active-list>li>ul{
  display: none;
  height: auto;
  float: left;
  width: 100%;
  padding: 5px 15px;
  border-top: 1px dashed #ccc
}

#nav .main-mobile .active-list>li.active>ul {
  display: block
}

#nav .main-mobile .active-list>li>ul>li {
  width: 100%;
  height: 20px;
  float: left;
  position: relative
}

#nav .main-mobile .active-list>li>ul>li>a {
  font-size: 12px;
  color: #333;
  text-transform: uppercase;
  text-decoration: none;
  opacity: 0.6;
  cursor: pointer
}

#nav .main-mobile .active-list>li.active>ul>li>i {
  background-image: url(https://website.obs.icheer.cn/icheer-web/images1/nav/arrow-right.png);
  transform: rotate(90deg)
}

@media screen and (max-width: 1380px) {
  #nav .main,#nav {
    height:5.2vw
  }

  #nav .main .logo{
    padding-top: 1.68vw;
    padding-left: 7.25vw
  }

  #nav .main .items {
    padding-top: 1.5vw;
    padding-right: 1.6vw
  }

  #nav .main .items>ul>li {
    margin: auto 5.1vw auto auto
  }

  #nav .main .items>ul>li a .title{
    font-size: 1.17vw;
    line-height: 2.2vw;
    padding-top: 0.2vw
  }

  #nav .main li:hover .title{
    border-bottom: 0.25vw solid #0151da
  }

  #nav .main .active-options{
    font-size: 0.99vw;
    left: -2.8vw;
    top: 3.7vw
  }

  #nav .main .active-list:hover .active-options{
    width: 10vw
  }

  #nav .main .active-options p {
    margin: 0;
    padding: 13px 0
  }
}

@media screen and (max-width: 768px) {
  #nav{
    width:100%;
    height: 40px;
    position: fixed;
    background-color: #fff
  }

  #nav .main{
    display: none
  }
  #nav .main-mobile {
    display: flex
  }
}

.navBox {
  width: 40px;
  height: 130px;
  position: fixed;
  background-color: #fff;
  bottom: 60px;
  right: 4px;
  border: 1px solid #eee;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.line {
  width: 30px;
  height: 1px;
  background-color: #eee;
}

.navBox .to-top {
  width: 40px;
  height: 40px;
  position: absolute;
  background-color: #fff;
  top: 135px;
  left: 0;
  border: 1px solid #eee;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.qrcode-part,.phone-text{
  font-size: 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: normal;
  color: black;
}
.phone-text{
  padding:10px 0;
}
</style>
